import React, { useEffect, useState, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './Banners.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Banners() {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef(null);

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [banners]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar banners:', error);
                setLoading(false);
            });
    };

    return (
        <div className='BannerContain'>
            {loading ? (
                <div className='loadingBanner'></div>
            ) : (
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    loop={banners.length > 1}
                    slidesPerView={'auto'}
                    coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                    autoplay={{ delay: 3500, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    id='swiper_container'
                >
                    {banners.map((item, index) => {
                        const bannerColor = item.color || '#2563eb';
                        return (
                            <SwiperSlide id='SwiperSlide-scroll' key={item.idBanner || index}>
                                <img
                                    src={item.imagen}
                                    alt={item.titulo || `Banner publicitario ${index + 1}`}
                                    loading={index === 0 ? "eager" : "lazy"}
                                    decoding="async"
                                    fetchpriority={index === 0 ? "high" : "low"}
                                    width="1200"
                                    height="450"
                                />
                                <div
                                    className='bannerOverlayText'
                                    style={{
                                        background: `linear-gradient(90deg, rgba(15, 23, 42, 0.88) 0%, ${bannerColor}44 45%, rgba(15, 23, 42, 0.4) 80%, rgba(0, 0, 0, 0.1) 100%)`
                                    }}
                                >
                                    <div className='bannerTextContent'>
                                        {item.titulo && <h2 className='bannerTitle'>{item.titulo}</h2>}
                                        {item.descripcion && <p className='bannerDesc'>{item.descripcion}</p>}
                                    </div>
                                    <div
                                        className='bannerBottomAccentLine'
                                        style={{
                                            background: `linear-gradient(90deg, ${bannerColor} 0%, ${bannerColor}aa 60%, transparent 100%)`
                                        }}
                                    />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
        </div>
    );
}
